import React from 'react';
import { Marker } from '@react-google-maps/api';
import pendingMarker from './assets/destination-pending.svg';
import confirmedMarker from './assets/destination-confirmed.svg';
import { DestinationMarkerProps, DestinationMarkerVariant } from './types';

const DestinationMarker: React.FC<DestinationMarkerProps> & DestinationMarkerVariant = (props) => {
  return <Marker {...props} />;
};

DestinationMarker.pending = (props) => (
  <DestinationMarker icon={pendingMarker} {...props} />
);

DestinationMarker.confirmed = (props) => (
  <DestinationMarker
    icon={{
      url: confirmedMarker,
      anchor: new window.google.maps.Point(12, 32),
    }}
    {...props} />
);

export default DestinationMarker;